import React from "react";
import "./styles.scss";
import { ProgressBar as Progress } from "react-bootstrap";

interface PropsI {
  rate: number;
  height?: number;
  noRoundedCorners?: boolean;
}

export const ProgressBar = (props: PropsI) => {
  const rate = props.rate === undefined ? 0 : props.rate;
  const height = props.height === undefined ? 10 : props.height;
  return (
    <div className="custom-progress-bar" title={rate.toFixed(1) + "%"}>
      <Progress
        style={{ height: `${height}px` }}
        now={rate}
        className={props.noRoundedCorners ? "ds-no-border-radius" : ""}
      />
    </div>
  );
};
